import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { recalcImageRatioFromTwips } from 'src/app/helpers/position-helpers';
import { Signature, SignatureType } from 'src/app/models/staff.model';
import { DialogService } from 'src/app/services/dialog.service';
import { DocumentDataService } from 'src/app/services/document-data.service';
import { StaffService } from 'src/app/services/staff.service';

declare const TXTextControl: any;

const underscoreRegex = new RegExp(`^S?_+s?`, 'm');
@Component({
  selector: 'tx-section-signatures',
  templateUrl: './section-signatures.component.html',
  styleUrls: ['./section-signatures.component.scss'],
})
export class SectionSignaturesComponent implements OnInit, OnDestroy {
  SignatureType = SignatureType;
  subscriptions = new Subscription();

  constructor(
    public staffService: StaffService,
    private dialogService: DialogService,
    private documentDataService: DocumentDataService
  ) {}

  ngOnInit(): void {
    this.staffService.fetchAll();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getSignature(id: string, type: SignatureType) {
    this.subscriptions.add(
      this.staffService
        .getSignature(
          id,
          this.documentDataService.getPraSysId(),
          this.documentDataService.getTemplateId(),
          this.documentDataService.getAnswers()
        )
        .subscribe({
          next: (response) => this.placeSignature(response, type),
        })
    );
  }

  toggleMenu(menu: NgbDropdown) {
    menu?.toggle();
    return false;
  }

  placeSignature(signature: Signature, type: SignatureType) {
    if (signature) {
      switch (type) {
        case SignatureType.IMAGE:
          if (signature.signatureImage) {
            TXTextControl.beginUndoAction('InsertImage', () => {
              this.insertImageSignature(signature, () => {
                TXTextControl.endUndoAction();
                TXTextControl.focus();
              });
            });
          } else {
            // If there is no image, show dialog with info on how to set this up.
            this.dialogService.info({
              title: `No signature image available for ${signature.name}`,
              message: 'You can configure signature images in TXdocs Firm Settings in the Manage Staff area.',
            });
          }
          break;
        case SignatureType.LETTER:
          TXTextControl.beginUndoAction('InsertPleading', () => {
            TXTextControl.selection.setText(signature.letterSig, () => {
              TXTextControl.selection.setText('\n', () => {
                TXTextControl.endUndoAction();
                TXTextControl.focus();
              });
            });
          });
          break;
        case SignatureType.PLEADING:
          const sigBlock = signature.sigBlock;
          if (signature.signatureImage) {
            const parts = sigBlock.split(underscoreRegex);

            let sigAddress = parts.length > 1 ? parts[0] : sigBlock;
            let sigDetails = parts.length > 1 ? parts[1].trimStart() : '';

            TXTextControl.beginUndoAction('InsertPleading', () => {
              TXTextControl.selection.setText(sigAddress, () => {
                this.insertImageSignature(signature, () => {
                  TXTextControl.selection.setText(sigDetails, () => {
                    TXTextControl.endUndoAction();
                    TXTextControl.focus();
                  });
                });
              });
            });
          } else {
            TXTextControl.selection.setText(sigBlock);
          }
          break;
        default:
          break;
      }
    }
  }

  private insertImageSignature(signature: Signature, callback: (image: any) => void) {
    TXTextControl.images.addAnchored(
      signature.signatureImage,
      TXTextControl.HorizontalAlignment.Left,
      -1,
      0,
      (img: any) => {
        img.getSize((size: any) => {
          img.setHorizontalScaling(recalcImageRatioFromTwips(size.width, signature.signatureImageW / 1000), () => {
            img.setVerticalScaling(recalcImageRatioFromTwips(size.height, signature.signatureImageH / 1000), () => {
              TXTextControl.selection.setText('\n', () => {
                callback(img);
              });
            });
          });
        });
      }
    );
  }
}
